'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$f = require('./styles-9361fa87.js');

var IconTextBlock = function (_a) {
    var text = _a.text, icon = _a.icon, linkRef = _a.linkRef, wrapText = _a.wrapText, iconType = _a.iconType, onClick = _a.onClick, shouldOpenInNewTab = _a.shouldOpenInNewTab;
    var resolveIcon = function () { return (iconType ? [iconType, icon] : ['fas', icon]); };
    return (React__default.createElement(styles$f.Container, { onClick: onClick || undefined },
        React__default.createElement(styles$f.Icon, { icon: resolveIcon() }),
        linkRef ? (React__default.createElement(styles$f.LinkContainer, { href: linkRef, wrapText: Boolean(wrapText), target: shouldOpenInNewTab ? '_blank' : '_self' }, text)) : (React__default.createElement(styles$f.TextContainer, { wrapText: Boolean(wrapText) }, text))));
};

exports.IconTextBlock = IconTextBlock;
